export const CONNECTION_PROFILE_FORM_TYPES = {
  ADD: "ADD",
  EDIT: "EDIT",
  CLONE: "CLONE",
};
